import * as Yup from 'yup'

export const createDiscountSchema = Yup.object().shape({
  name: Yup.string().required('Discount name is required'),
  isActive: Yup.boolean().required('Active flag  is required'),
  start: Yup.string().notRequired(),
  finish: Yup.string().notRequired(),
  is_allow_to_sell_loss:Yup.boolean()
})
